<template>
  <div class="customerSalesReportLine">
    <div class="vm-search">
      <vm-search label="区域">
        <el-input v-model="params.salePersonDirector" placeholder="请输入" clearable/>
      </vm-search>
      <vm-search label="销售助理" :value-width="130">
        <el-input v-model="params.salePersonName" placeholder="请输入" clearable/>
      </vm-search>
      <vm-search label="客户" :value-width="200">
        <el-input v-model="params.customerName" placeholder="请输入" clearable/>
      </vm-search>
      <vm-search-date
          label="开始时间"
          :start-time.sync="params.startTime"
          :end-time.sync="params.endTime"/>
      <vm-search label="查询方式" :value-width="45">
        <el-select v-model="params.queryType" placeholder="请选择">
          <el-option label="日" :value="0"/>
          <el-option label="周" :value="1"/>
          <el-option label="月" :value="2"/>
        </el-select>
      </vm-search>
      <vm-search label="只看汇总" :value-width="20">
        <el-checkbox v-model="params.onlySummaryRow"/>
      </vm-search>
      <vm-search :value-width="150" style="margin-left: 6px">
        <el-button :loading="submitLoading" type="primary" style="padding: 6px 8px" @click="getList">查询</el-button>
        <el-button :loading="exportLoading" type="success" style="padding: 6px 8px" @click="handleExport">导出</el-button>
      </vm-search>
      <el-table
          v-if="dateColumNames"
          ref="elTable"
          border
          :row-style="rowStyle"
          :data="tableData"
          style="margin-top: 8px;"
          height="calc(100vh - 175px)">
        <el-table-column
            prop="salePersonDirector"
            label="区域"
            align="center"
            fixed="left"
            width="150"/>
        <el-table-column
            prop="salePersonName"
            label="销售助理"
            align="center"
            fixed="left"
            width="230"/>
        <el-table-column
            prop="customerName"
            label="客户"
            align="center"
            fixed="left"
            width="230"/>
        <el-table-column
            prop="finalCustomerName"
            fixed="left"
            align="center"
            label="终端客户"
            width="230"/>
        <template v-if="dateColumNames">
          <el-table-column
              v-for="(item,index) in dateColumNames"
              :key="item.columnName"
              :min-width="(item.columnName==='汇总(W)'||item.columnName==='未审核汇总(W)'||item.order==='now')?100:160"
              :label="item.columnName">
            <template v-slot="scope">
              <div v-if="item.columnName === '逾期汇总(W)'" title="今日之前应发货过账且未完成过账的发货单总金额" class="cellDiv">
                <i class="el-icon-star-on" style="color: #d81e19;"/>
                {{scope.row.dateColumns[index].overduePriceDesc}}
              </div>
              <div v-else-if="item.columnName === '未审核汇总(W)'" title="今日及之后未审核发货单总金额" class="cellDiv">
                <i class="el-icon-star-on" style="color: #d81e19;"/>
                {{scope.row.dateColumns[index].unauditedPriceDesc}}
              </div>
              <template v-else>
                <div title="发货金额" class="cellDiv">
                  <i class="el-icon-star-on" style="color: #d81e19;"/>
                  <span v-if="item.order==='before'" title="已发货过账金额">
                    {{scope.row.dateColumns[index].deliveryBillBeforePriceDesc}}
                  </span>
                  <span v-else-if="item.order==='after'" title="待发货金额">
                    {{scope.row.dateColumns[index].deliveryBillAfterPriceDesc}}
                  </span>
                  <template v-else>
                    <span title="已发货过账金额"> {{scope.row.dateColumns[index].deliveryBillBeforePriceDesc}}</span>
                    <!--                    <span title="已发货过账金额"> {{scope.row.dateColumns[index].deliveryBillBeforePriceDesc}}/</span>-->
                    <!--                    <span title="待发货金额">{{scope.row.dateColumns[index].deliveryBillAfterPriceDesc}}</span>-->
                  </template>
                </div>
                <div title="销单未开发货单金额" class="cellDiv">
                  <i class="el-icon-star-on" style="color: #32b356;"/>
                  {{scope.row.dateColumns[index].notBilledPriceDesc}}
                </div>
                <div title="销售单金额" class="cellDiv">
                  <i class="el-icon-star-on" style="color: #E6A23C;"/>
                  {{scope.row.dateColumns[index].saleOrderPriceDesc}}
                </div>
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
  import VmSearchDate from "@/components/VmSearchDate.vue";
  import VmSearch from "@/components/v2/VmSearch.vue";

  export default {
    name: "CustomerSalesReportBu",
    components: {VmSearch, VmSearchDate},
    data() {
      return {
        submitLoading: false,
        exportLoading: false,
        params: {
          startTime: "",
          endTime: "",
          queryType: 0,
          salePersonDirector: "",
          salePersonName: "",
          customerName: "",
          finalCustomerName: "",
          onlySummaryRow: false,
        },
        tableData: [],
        dateColumNames: null,
      };
    },
    methods: {
      getList() {
        if (!this.params.startTime || !this.params.endTime) {
          this.$message.error("请输入日期");
          return;
        }
        this.submitLoading = true;
        this.$http
            .post("basic", "saleStats/byBu", this.params)
            .then(res => {
              this.tableData = res.data;
              if (res && res.data.length) {
                this.dateColumNames = res.data[0].dateColumns;
              }
              this.$message.success("获取成功");
              this.$nextTick(() => {
                this.$refs.elTable.doLayout();
              });
            })
            .finally(() => {
              this.submitLoading = false;
            });
      },
      rowStyle({row}) {
        return row.isSummaryRow ? {backgroundColor: "skyblue"} : {};
      },
      handleExport() {
        this.$confirm("确定导出吗?", "提示", {type: "warning"}).then(() => {
          this.exportLoading = true;
          this.$http.exportExcelByHeader("basic", "saleStats/byBu", this.params, "post")
              .finally(() => {
                this.exportLoading = false;
              });
        });
      },
    },
  };
</script>
<style lang="scss">
.customerSalesReportLine {
  .el-table__body tr.hover-row > td.el-table__cell {
    background-color: unset !important;
  }

  .el-table__fixed::before, .el-table__fixed-right::before {
    background-color: unset !important;
  }

  .cellDiv {
    line-height: 14px;
    display: flex;
    align-items: center;

    i {
      margin-right: 2px;
    }
  }
}
</style>
